var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"modal",class:_vm.current.type},[_c('span',{staticClass:"close-button",on:{"click":_vm.dismiss}},[_c('i',{staticClass:"fas fa-times"})]),_vm._v(" "),_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.current.body)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }